export default () => {
  return `#import <UIKit/UIKit.h>
@interface ViewController : UIViewController

@end`;
};
